import React from "reactn";

import PropTypes from "prop-types";

//components
import NumberInput from "../../../_common/form/number_input/NumberInput";

// styled components
import SpaceBetweenContainer from "../../../_common/containers/SpaceBetweenContainer";

const CollectableInner = props => {
    const { values, name, id } = props;
    return (
        <SpaceBetweenContainer>
            <div className="CollectableDesc">
                {name}
            </div>
            <NumberInput numberValue={id} values={values}></NumberInput>
        </SpaceBetweenContainer>
    );
};

CollectableInner.propTypes = {
    values: PropTypes.array,
    name: PropTypes.string,
    id: PropTypes.string
};

export default CollectableInner;
